import { render, staticRenderFns } from "./Addmember.vue?vue&type=template&id=394105b2&scoped=true&"
import script from "./Addmember.vue?vue&type=script&lang=js&"
export * from "./Addmember.vue?vue&type=script&lang=js&"
import style0 from "./Addmember.vue?vue&type=style&index=0&id=394105b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394105b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/ChunjuanLiu/Documents/Jobhunting/Projects/Front end/Web development/Other projects/Task Management/task/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VDataTable,VDialog,VForm,VSelect,VSpacer,VTextField})
